import { render, staticRenderFns } from "./cert.vue?vue&type=template&id=619998b1&scoped=true"
import script from "./cert.vue?vue&type=script&lang=js"
export * from "./cert.vue?vue&type=script&lang=js"
import style0 from "./cert.vue?vue&type=style&index=0&id=619998b1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619998b1",
  null
  
)

export default component.exports